import { PackageCarrier, PackageCarrierSchema } from '@/models'

const CARRIER_NAME_MAP: Record<PackageCarrier, string> = {
  [PackageCarrierSchema.enum.amazon]: 'Amazon',
  [PackageCarrierSchema.enum.dhl]: 'DHL',
  [PackageCarrierSchema.enum.fedex]: 'FedEx',
  [PackageCarrierSchema.enum.other]: 'Other',
  [PackageCarrierSchema.enum.ups]: 'UPS',
  [PackageCarrierSchema.enum.usps]: 'USPS',
}

// Note: accepts `string` (not just `PackageCarrier`) because some API responses
// (e.g. package room session logs) return free-form carrier strings that may fall
// outside the known enum; unknown values fall back to 'Other'.
export const getCarrierName = (carrier: string): string => {
  return CARRIER_NAME_MAP[carrier as PackageCarrier] ?? 'Other'
}
